export default __webpack_public_path__ + "info-icon.14b82d38e406440640385669557d2aa0.svg";